/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotificationPolicyConfigEmail {
  /**
  * The email to send the notification to
  */
  'email'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "email",
      "baseName": "email",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfigEmail.attributeTypeMap;
  }

  public constructor() {
  }
}

